import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import { useSelector, useDispatch } from "react-redux";
import Layout from "../components/Layout";
import { Modal } from "react-bootstrap";
import { addDoc, collection } from "firebase/firestore";
import fireDb from "../fireconfig";

import "../assets/css/Cartpage.scss";
import { toast } from "react-toastify";

const Cartpage = () => {
  const { cartItems } = useSelector((state) => state.cartReducer);
  const dispatch = useDispatch();
  const [total, setTotal] = useState(0);
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    var temp = 0;
    cartItems.forEach((cartItem) => {
      temp = temp + cartItem.price;
    });
    setTotal(temp);
  }, [cartItems]);

  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const deleteFromCart = (product) => {
    dispatch({ type: "DELETE_FROM_CART", payload: product });
  };

  const placeorder = async () => {
    const shippingAddress = {
      name,
      address,
      city,
      pincode,
      phonenumber,
    };

    const orderInfo = {
      cartItems,
      total,
      shippingAddress,
      email: JSON.parse(localStorage.getItem("currentUser")).user.email,
      userId: JSON.parse(localStorage.getItem("currentUser")).user.uid,
    };

    try {
      setLoading(true);
      const result = await addDoc(collection(fireDb, "orders"), orderInfo);
      setLoading(false);
      toast.success("Order placed successfully");
      handleClose();
    } catch (error) {
      setLoading(false);
      toast.error("Order failed");
    }

    localStorage.removeItem("cartItems");
    setTimeout(function () {
      window.location.reload();
    }, 6000);
  };
  return (
    <Layout loading={loading}>
      <table className="table cart_table">
        <thead>
          <tr>
            <th scope="col">Image</th>
            <th scope="col">Name</th>
            <th scope="col" className="text-center">
              Price
            </th>
            <th scope="col" className="text-center">
              Delete
            </th>
          </tr>
        </thead>
        <tbody>
          {cartItems.map((item) => {
            return (
              <tr key={item.title}>
                <td>
                  <img
                    src={item.image}
                    alt={item.title}
                    height="150"
                    width="225"
                  />
                </td>
                <td>
                  <p>{item.title}</p>
                  <p className="cart-item-description">{item.description}</p>
                </td>
                <td className="text-center">{item.price}/-</td>
                <td className="text-center">
                  <FaTrash onClick={() => deleteFromCart(item)} />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div className="d-flex justify-content-end">
        <h5>Total: ₹ {total}/-</h5>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-success" onClick={handleShow}>
          Place Order
        </button>
      </div>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Place Order</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="place_order_section">
            <h4>Address</h4>
            <hr />
            <input
              type="text"
              className="form-control input_field"
              placeholder="Name"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <textarea
              rows={3}
              type="text"
              className="form-control input_field"
              placeholder="Address"
              value={address}
              onChange={(e) => {
                setAddress(e.target.value);
              }}
            />
            <div className="d-flex">
              <input
                type="text"
                className="form-control input_field mt-0 mb-0"
                style={{ marginRight: ".5rem" }}
                placeholder="City"
                value={city}
                onChange={(e) => {
                  setCity(e.target.value);
                }}
              />
              <input
                type="number"
                onWheel={(e) => e.target.blur()}
                className="form-control input_field mt-0 mb-0 ml-1"
                style={{ marginLeft: ".5rem" }}
                placeholder="Pincode"
                value={pincode}
                onChange={(e) => {
                  setPincode(e.target.value);
                }}
              />
            </div>
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              className="form-control input_field"
              placeholder="Phone number"
              value={phonenumber}
              onChange={(e) => {
                setPhonenumber(e.target.value);
              }}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-success" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-success" onClick={placeorder}>
            Place Order
          </button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
};

export default Cartpage;
